/**
 * 繰り返し使う文字たち
 */
export const messages = {
  loading: '読み込み中',
};
